import styled from 'styled-components';

export const LoginContainer = styled.div`
  width: 100%;
  min-height: 100dvh;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
`;

export const Logo = styled.img`
  width: 139px;
  padding: 16px;
`;

export const LoginTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;

export const LoginForm = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const LoginForgotPassword = styled.div`
  width: 100%;
  text-align: center;
  padding: 16px;
`;

export const LoginButtons = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const AnimatedContent = styled.div<{ isVisible: boolean }>`
  transform: translateY(${props => (props.isVisible ? '0' : '100%')});
  opacity: ${props => (props.isVisible ? '1' : '0')};
  transition:
    transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    opacity 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: transform, opacity;
  backdrop-filter: blur(28px);
  background: rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 100%;
`;
